import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_RADIUS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface WhyItWorksBoxProps {
  text: string;
  boldKeywords?: string[]; // Optional for backward compatibility
}

/**
 * WhyItWorksBox Component
 * 
 * "Why this works" informational box with light blue background.
 * Responsive: Text scales 16px → 18px → 20px, title scales 20px → 22px → 24px.
 */
export default function WhyItWorksBox({ text }: WhyItWorksBoxProps) {
  // Helper to render text with bold keywords
  const renderText = (text: string) => {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        const boldText = part.slice(2, -2);
        return (
          <strong key={index} className="font-semibold">
            {boldText}
          </strong>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div
      className="mt-6 mx-6 sm:mx-8 md:mx-10 lg:mx-12"
      style={{
        backgroundColor: ACTIVITY_DETAILS_COLORS.infoBoxBg,
        borderRadius: `${ACTIVITY_DETAILS_RADIUS.infoBox}px`,
        padding: '16px',
      }}
    >
      {/* Title */}
      <h3
        className={`${ACTIVITY_DETAILS_TYPOGRAPHY.sectionHeader.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.sectionHeader.sizeClasses} ${ACTIVITY_DETAILS_TYPOGRAPHY.sectionHeader.tracking}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: ACTIVITY_DETAILS_COLORS.infoBoxText,
          margin: 0,
          marginBottom: '8px',
          lineHeight: 1,
        }}
      >
        Why this works
      </h3>

      {/* Text */}
      <p
        className={`${ACTIVITY_DETAILS_TYPOGRAPHY.body.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.sizeClasses}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: ACTIVITY_DETAILS_COLORS.textPrimary,
          margin: 0,
          lineHeight: 1.6,
        }}
      >
        {renderText(text)}
      </p>
    </div>
  );
}
